module.exports = __webpack_public_path__ + "static/media/image3.db9d2b4e.jpg";